'use client';
import { jsx as l } from "react/jsx-runtime";
import { cn as a } from "@tameeni/shared-logic";
function n(e) {
  const { type: i, locale: d = "ar" } = e;
  if (i === "video") {
    if (!e.videoData) return null;
    const { videoData: t } = e;
    return /* @__PURE__ */ l(
      "div",
      {
        className: a(
          "w-full max-w-md lg:w-2/5 h-fit lg:min-h-96 py-2 flex justify-center items-center"
        ),
        children: /* @__PURE__ */ l(
          "div",
          {
            className: a(
              "w-full rounded-md overflow-hidden border-2 border-blue-200",
              e.videoClassName
            ),
            children: /* @__PURE__ */ l(
              "video",
              {
                src: t.src,
                controls: !0,
                className: "w-full h-full",
                preload: "false"
              }
            )
          }
        )
      }
    );
  }
  const { imageSrc: r } = e;
  return /* @__PURE__ */ l("div", { className: a("w-full max-w-md lg:w-2/5"), children: /* @__PURE__ */ l(
    "img",
    {
      loading: "eager",
      src: r,
      alt: e.alt,
      className: a("w-full h-auto", e.imageClassName)
    }
  ) });
}
export {
  n as MediaSection
};
//# sourceMappingURL=hero-media.js.map
